import { render, staticRenderFns } from "./derucci.vue?vue&type=template&id=6d4f13d7&scoped=true&"
import script from "./derucci.vue?vue&type=script&lang=js&"
export * from "./derucci.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f13d7",
  null
  
)

export default component.exports